import {
  Dialog,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
} from "@devhop/ui";
import type { CheckInListItem } from "../api/client";
import { CheckInClassForm } from "./CheckInClassForm";
import { CheckInPrivateForm } from "./CheckInPrivateForm";

type CheckInModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: CheckInListItem | null;
  onSuccess: () => void;
};

export function CheckInModal({
  open,
  onOpenChange,
  item,
  onSuccess,
}: CheckInModalProps) {
  if (!item) return null;

  const isClass = item.type === "general_class";
  const capacity = isClass ? item.capacity : undefined;
  const attendanceCount = isClass ? item.attendanceCount : undefined;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          className={
            isClass
              ? "h-full max-h-[90vh] max-w-4xl gap-0 overflow-y-auto p-0 sm:max-w-4xl"
              : "max-w-2xl gap-0 p-0 sm:max-w-2xl"
          }
        >
          <div className="flex flex-col sm:flex-row">
            <div className="flex flex-1 flex-col gap-4 p-6">
              <DialogTitle className="font-semibold text-lg">
                {isClass
                  ? `ກວດຊື່: ${item.subjectOrStudent}`
                  : `ກວດຊື່: ${item.subjectOrStudent}`}
              </DialogTitle>
              <p className="text-muted-foreground text-sm">
                ຄູສອນ: {item.instructorNames?.join(", ") ?? "-"} •{" "}
                {item.roomName}
              </p>
              {isClass &&
                item.engagementKind === "partner_instructor_only" && (
                  <p className="rounded-md border border-border bg-muted/40 p-3 text-muted-foreground text-xs">
                    Partner (ເຊັກຊື່ຄູເທົ່ານັ້ນ): ໜ້ານີ້ສຳລັບເຊັກຊື່ຄູເທົ່ານັ້ນ ບໍ່ມີການຕັດແພັກເກດນັກຮຽນ.
                  </p>
                )}

              {isClass && (
                <CheckInClassForm
                  sessionId={item.id}
                  capacity={capacity ?? 0}
                  attendanceCount={attendanceCount ?? 0}
                  instructorIds={item.instructorIds ?? []}
                  instructorNames={item.instructorNames ?? []}
                  instructors={item.instructors}
                  sessionDate={item.date}
                  onSuccess={onSuccess}
                  onCheckInComplete={() => {
                    onSuccess();
                    onOpenChange(false);
                  }}
                  onCancel={() => onOpenChange(false)}
                />
              )}
              {item.type === "private_lesson" && (
                <CheckInPrivateForm
                  bookingId={item.id}
                  studentName={item.subjectOrStudent}
                  studentMemberId={item.studentMemberId}
                  packageKind={item.packageKind}
                  instructorIds={item.instructorIds ?? []}
                  instructorNames={item.instructorNames ?? []}
                  onSuccess={onSuccess}
                  onCheckInComplete={() => {
                    onSuccess();
                    onOpenChange(false);
                  }}
                  onCancel={() => onOpenChange(false)}
                />
              )}
            </div>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
